// В.2.f-2: Токсичное облако (liv_toksichnoe_oblako, legendary Действие).
// «Наносит 2 урона всем вражеским персонажам (включая Героя) и лечит
//  всех своих юнитов на 2 ХП».
//
// Без picker'а — эффект автоматический.
//
// Поведение:
//   - 2 урона каждому ВРАЖЕСКОМУ юниту через applyDamage (стандартный
//     путь: Иммунитет, Броня, Пробитие учитываются; on_damage_taken
//     срабатывает — Альфа получает +N atk; on_unit_died срабатывает,
//     если юнит умер — Реаниматор противника лечит ВРАЖЕСКОГО Героя).
//   - 2 урона ВРАЖЕСКОМУ Герою через applyHeroDamage (Иммунитет Героя
//     учитывается, Парашют учитывается, Тёмный нетраннер триггерит).
//   - 2 ХП каждому СВОЕМУ юниту через healUnit (триггерит событие
//     healed: Ошибка эксперимента +1 atk).

import { applyDamage } from '../../combat.js';
import { applyHeroDamage } from '../../hero-damage.js';
import { dispatchUnitDied } from '../deus/hooks.js';
import { healUnit } from './heal.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_toksichnoe_oblako';
const LABEL = 'Токсичное облако';
const DAMAGE = 2;
const HEAL = 2;

registerImplementedAbility(CARD_ID, 'oneshot');

export function actionTargets(_state, _playerIdx) {
  return [];
}

export function resolve(state, playerIdx /*, target, opts */) {
  const me = state.players?.[playerIdx];
  const enemy = state.players?.[1 - playerIdx];
  if (!me || !enemy) return { ok: true, skipped: true };
  state.log?.add(`☠ ${LABEL}: 2 урона всем врагам / +2 ХП всем своим юнитам`);
  // 1) 2 урона всем вражеским юнитам.
  // Снимок — иначе если юнит умрёт и его removeFromField сдвинет состав,
  // итерация может пропустить кого-то. Снимок гарантирует «один тик» по
  // всем целям на момент розыгрыша.
  const enemyUnits = enemy.unitsOnField().slice();
  for (const u of enemyUnits) {
    if (!u.isAlive()) continue;
    applyDamage(u, DAMAGE, { state, source: { id: CARD_ID, name_ru: LABEL } });
    if (u.current.hp <= 0) {
      enemy.removeFromField(u);
      state.log?.add(`✗ ${u.name_ru} [${enemy.name}] погибает (от ${LABEL})`);
      dispatchUnitDied(state, {
        ownerIdx: 1 - playerIdx, card: u, killer: null, killerIdx: playerIdx, killerWasCounter: false
      });
    }
  }
  // 2) 2 урона вражескому Герою.
  if (enemy.hero && enemy.hero.hp > 0) {
    applyHeroDamage(state, 1 - playerIdx, DAMAGE, { sourceLabel: LABEL });
  }
  // 3) +2 ХП всем своим живым юнитам.
  const allies = me.unitsOnField().slice();
  for (const a of allies) {
    if (!a.isAlive()) continue;
    healUnit(state, a, HEAL, { id: CARD_ID, name_ru: LABEL, type: 'action' });
  }
  return { ok: true };
}
